import dayjs, { Dayjs } from "dayjs";
import React, { useState, useRef, useEffect } from "react";
import "./index.less";
import { Tooltip, Modal, Button, Input, message } from "antd";
import QuickCreateDatePicker from "./DatePicker";
import IconFont from "@/components/icon";

export default function QuickCreateModal(props: any) {
  const {
    t,
    visible,
    onOk,
    onMore,
    title,
    beginTime,
    endTime,
    onDragCreateTitleChange,
    onBeginTimeChange,
    onEndTimeChange
  } = props;
  const inputRef: any = useRef(null);
  useEffect(() => {
    console.log("inputRef~~~~:", inputRef.current);
    if (visible) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 200);
    }
  }, [visible]);
  const handleTimeChange = async (time: Dayjs | null, start: any = true, isAllDay?: boolean) => {
    const unix = time ? time : null;
    const { t } = props;
    if (start) {
      if (unix === beginTime) {
        return;
      }
      onBeginTimeChange(unix);
      if (!endTime || (!!endTime && !!unix && unix?.add(30, "minute").isAfter(endTime, "minute"))) {
        onEndTimeChange(unix?.add(30, "minute") || endTime);
      }
      return;
    }
    if (unix === endTime) {
      return;
    }
    if (beginTime?.add(30, "minute").isAfter(time, "minute")) {
      return message.warn(t("deadline is at least 30 minutes later than the start time"));
    }
    onEndTimeChange(unix);
    return;
  };
  return (
    <Modal
      className="quick-create-modal"
      wrapClassName="quick-create-modal-wrap"
      {...props}
      mask={false}
      destroyOnClose={true}
      title="快速新建日程"
      footer={
        <div>
          <Button type="default" onClick={onMore}>
            更多选项
          </Button>
          <Button type="primary" onClick={onOk}>
            确定
          </Button>
        </div>
      }
    >
      <div className="df calendar-content mb20">
        <IconFont className="title-icon" type="iconic_calendar" />
        <div className="calendar-title-content">
          <Input
            ref={inputRef}
            placeholder="请输入日程标题（必填）"
            value={title}
            maxLength={100}
            onPressEnter={onOk}
            onKeyPress={() => {
              if (title.length >= 100) {
                message.destroy();
                return message.warn(t("title limit 100"));
              }
            }}
            className="calendar-custom-textarea schedule-textarea"
            onChange={(e) => {
              onDragCreateTitleChange(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="df calendar-content">
        <IconFont className="time-icon" type="iconic_time_" />
        <div className="calendar-date-content">
          <div className="df calendar-date">
            <QuickCreateDatePicker
              isAllDay={false}
              disable={true}
              time={beginTime || null}
              onChange={(time: Dayjs | null) => handleTimeChange(time, true, false)}
              placeholder={t("set start time")}
              isDateFormat={true}
              isChangeHeaderVisible={true}
            />
          </div>
          <span className="df separator" />
          <div className="df calendar-date">
            <QuickCreateDatePicker
              isAllDay={false}
              hideDate={true}
              time={endTime || null}
              onChange={(time: Dayjs | null) => handleTimeChange(time, false, false)}
              placeholder={t("set end time")}
              isDateFormat={true}
              isChangeHeaderVisible={true}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
